var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.getClassName("quantity") },
    [
      _c("v-text-field", {
        class: _vm.getClassName("quantity__field"),
        attrs: {
          type: "number",
          min: "1",
          outlined: "",
          "hide-details": "",
          dense: ""
        },
        model: {
          value: _vm.internalValue,
          callback: function($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue"
        }
      }),
      _vm._v(" "),
      _vm.item.unit !== ""
        ? _c("span", { class: _vm.getClassName("quantity__unit") }, [
            _vm._v(_vm._s(_vm.item.unit))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }